import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M8 21s-4-3-4-9 4-9 4-9", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M16 3s4 3 4 9-4 9-4 9", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "15", x2: "9", y1: "9", y2: "15", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "9", x2: "15", y1: "9", y2: "15", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Variable";
const Variable = memo(themed(Icon));
export {
  Variable
};
//# sourceMappingURL=variable.js.map
